import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import QQPlayerEmbed from "./players/QQPlayerEmbed";
import VidyardPlayerEmbed from "./players/VidyardPlayerEmbed";
import VimeoPlayerEmbed from "./players/VimeoPlayerEmbed";
import YouTubePlayerEmbed from "./players/YouTubePlayerEmbed";
import KalturaPlayerEmbed from "./players/KalturaPlayerEmbed";

var VideoPlayerEmbed = function VideoPlayerEmbed(_ref) {
  var kind = _ref.kind,
      frameProps = _objectWithoutProperties(_ref, ["kind"]);

  var frame;

  switch (kind) {
    case "qq":
      frame = /*#__PURE__*/React.createElement(QQPlayerEmbed, frameProps);
      break;

    case "vidyard":
      frame = /*#__PURE__*/React.createElement(VidyardPlayerEmbed, frameProps);
      break;

    case "vimeo":
      frame = /*#__PURE__*/React.createElement(VimeoPlayerEmbed, frameProps);
      break;

    case "youtube":
      frame = /*#__PURE__*/React.createElement(YouTubePlayerEmbed, frameProps);
      break;

    case "kaltura":
      frame = /*#__PURE__*/React.createElement(KalturaPlayerEmbed, frameProps);
      break;

    default:
      frame = null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: frameProps.getClassName({
      descendantName: "player"
    })
  }, frame);
};

export default VideoPlayerEmbed;